import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import moment from 'moment';
import {AdxSbBookingMatch} from '../model/adx-sb-booking-match';
import {AdxSbReconciliationFilterService} from './adx-sb-reconciliation-filter.service';

@Injectable({
  providedIn: 'root'
})
export class AdxSbBookingGridService implements GridGetService<AdxSbBookingMatch> {
  private readonly baseUrl = 'dbov2/adx-sb-reconciliation/bookings';
  private readonly http = inject(HttpClient);
  private readonly filterService = inject(AdxSbReconciliationFilterService);

  getItems({page, sort}: GridServiceParams): Observable<GridServiceResponse<AdxSbBookingMatch>> {
    const filters = this.filterService.filtersValue();

    const params: Record<string, string | number | boolean> = {
      pageSize: page?.pageSize || 25,
      pageNumber: (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || 'recordLocator',
      orderKey: sort?.direction || 'asc',
      from: filters?.From ? moment(filters.From).format('YYYY-MM-DD') : '',
      to: filters?.To ? moment(filters.To).format('YYYY-MM-DD') : '',
      day: filters?.Day ? moment(filters.Day).format('YYYY-MM-DD') : '',
      onlyMismatches: filters?.OnlyMismatches ?? '',
      recordLocator: filters?.RecordLocator ?? '',
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<AdxSbBookingMatch>>(`${this.baseUrl}`, {params: {...params}})
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
      }));
  }
}
